import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useChapterCompletion, useDelete: useChapterCancelCompletion } = getCRUDHooks({
  entityName: 'chapterCompletion',
  create: (chapterId: number) =>
    clientApi.getOCClient().helpers.learningContent.chapters.completeChapter(chapterId),
  remove: (chapterId: number) =>
    clientApi.getOCClient().helpers.learningContent.chapters.cancelCompleteChapter(chapterId),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useChapterCompletion,
  useChapterCancelCompletion,
};
